module.exports = __webpack_public_path__ + "static/media/24UHCHR7.cee91c5a.jpg";